/**
 * Detects whether the Profitwell Retain script is blocked by an ad blocker.
 * Caches the result so the bait request runs at most once per session.
 */
let profitwellBlockPromise: Promise<boolean> | null = null;

const PROFITWELL_SCRIPT_URL =
    'https://public.profitwell.com/js/profitwell.js?auth=paddletoken_live_6d9351b5eeca0d4a88201dd1747';

export function detectProfitwellBlock(): Promise<boolean> {
    if (profitwellBlockPromise) return profitwellBlockPromise;

    // SSR / non-browser guard — never block in environments without DOM.
    if (typeof document === 'undefined') {
        profitwellBlockPromise = Promise.resolve(false);
        return profitwellBlockPromise;
    }

    profitwellBlockPromise = new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = PROFITWELL_SCRIPT_URL;
        script.async = true;
        let resolved = false;

        const finish = (blocked: boolean) => {
            if (resolved) return;
            resolved = true;
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
            resolve(blocked);
        };

        script.onload = () => finish(false);
        script.onerror = () => finish(true);

        // Some blockers silently drop the request without firing onerror,
        // so treat a hanging load as blocked after 3 seconds.
        setTimeout(() => finish(true), 3000);
        document.head.appendChild(script);
    });

    return profitwellBlockPromise;
}
